import React from 'react';
import { motion } from 'framer-motion';
import { MEDIA_URL } from '../../axios';
import Akshay01 from '../../Assets/AboutUs/Akshay01.jpg';

const OurObjective = () => {
  const aboutsplashbg = MEDIA_URL + 'Home/OurSolutionbg.png';

  const imageVariant = {
    hidden: { opacity: 0, x: 100, scale: 0.9 },
    visible: {
      opacity: 1,
      x: 0,
      scale: 1,
      transition: { type: 'spring', stiffness: 60, damping: 14, delay: 0.2 },
    },
  };

  const textVariant = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.18, delayChildren: 0.1 },
    },
  };

  const lineVariant = {
    hidden: { opacity: 0, x: -40 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { type: 'spring', stiffness: 60, damping: 14 },
    },
  };

  return (
    <div className='relative overflow-hidden h-auto md:h-[60vh] flex items-center max-sm:items-start justify-start py-10 md:py-30 mt-10'>
      {/* Sliding Image Animation */}
      <motion.img
        src={Akshay01}
        alt="Our Objective"
        className='max-md:hidden max-sm:w-full md:max-xl:top-[8vh] md:max-xl:right-4 md:max-xl:w-[45vw] w-[48vw] mt-24 right-10 absolute z-0'
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={imageVariant}
        animate={{ y: [0, -10, 0] }}
        transition={{ y: { duration: 5, repeat: Infinity, ease: 'easeInOut', delay: 1.2 } }}
      />
      <motion.div
        className='flex flex-col herobg2 max-sm:gap-4 max-sm:px-6 px-14 gap-8 z-10'
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={textVariant}
      >
        <motion.img
          variants={lineVariant}
          src={aboutsplashbg}
          alt="About Us"
          className="max-sm:top-[6%] max-sm:w-[50vw] max-sm:left-[20%] sm:max-xl:top-[5vh] sm:max-xl:right-[35vw] sm:max-xl:w-[27vw] w-[35vw]  right-[60vw] absolute -z-10"
        />
        <motion.p variants={lineVariant} className='purple msg-md md:text-2xl text-2xl font-semibold'>
          Insights from the Managing Director
        </motion.p>
        <div className='max-sm:w-full text-justify w-[95%] flex flex-col gap-4'>
          <motion.p
            variants={lineVariant}
            className='max-sm:w-full sm:max-xl:w-[55%] w-[50%] leading-relaxed text-sm md:text-md'
          >
            At Saptagon Asia Pvt Ltd (formerly known as G Eng Advisory Pvt Ltd), our journey
            over the past decade has positioned us as leaders in infrastructure
            consultancy. With our super team of over 500+ professionals,
            we've excelled in highway design, authority engineering, bridges, tunnels,
            and more.
          </motion.p>
          <motion.p
            variants={lineVariant}
            className='max-sm:w-full sm:max-xl:w-[55%] w-[50%] leading-relaxed text-sm md:text-md'
          >
            Looking ahead, our focus for this decade is on advancing sustainable
            infrastructure solutions through cutting-edge technology.
            We remain committed to maintaining leadership in excellence, innovation,
            and sustainability, aiming to create impactful infrastructure that drives
            economic growth and enhances community well-being.
          </motion.p>
          <motion.p
            variants={lineVariant}
            className='max-sm:w-full sm:max-xl:w-[55%] w-[50%] leading-relaxed text-sm md:text-md'
          >
            Thank you for your continued support as we navigate this exciting path forward.
            <br />
            <br />

            Warm regards, <br />
            Akshay Kumar
          </motion.p>
        </div>
        {/* Mobile Image Animation */}
        <div className='md:hidden flex justify-center items-start'>
          <motion.img
            src={Akshay01}
            alt="Quality Policy"
            className='w-full rounded-lg'
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={imageVariant}
          />
        </div>
      </motion.div>
    </div>
  );
};

export default OurObjective;